import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
// import createBrowserHistory from 'history';

import './App.css';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import NavBar from './_Componants/DefaultLayout/NavBar';
import HomeContainer from './_Containers/Home/Home';
import AboutContainer from './_Containers/About/About';
import ContactUsContainer from './_Containers/Contactus/ContactUs';
import CareersContainer from './_Containers/Careers/CareersConainer';
import ProductsContiner from './_Containers/Products/ProductsContainer';
import ServicesContainer from './_Containers/Services/ServicesContainer';
import Footer from './_Componants/DefaultLayout/Footer';

function App() {

  return (
    <Router>
      <NavBar />
      <div className="content-area">
        <Switch>
          <Route path={['/', '/Home']} exact component={HomeContainer} />
          <Route path={'/About'} component={AboutContainer} />
          <Route path={'/Contactus'} component={ContactUsContainer} />
          <Route path={'/Careers'} component={CareersContainer} />
          <Route path={'/Services'} component={ServicesContainer} />
          <Route path={'/Products'} component={ProductsContiner} />
        </Switch>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
